import type { PageType } from "../type"

export const sortPage = (pageA: PageType, pageB: PageType) => {
  if (pageA.isDefault > pageB.isDefault) {
    return -1;
  }

  if (pageA.isScheduled > pageB.isScheduled) {
    return -1;
  }

  if (pageA.isInCampaign > pageB.isInCampaign) {
    return -1;
  }

  return 0;
}
